import { gql } from '__generated__'

export const UpdateSourceStatus = gql(/* GraphQL */ `
    mutation UpdateSourceStatus(
        $rosterCandidateIds: [ID!]!
        $sourceStatus: RosterSourceStatus!
    ) {
        updateRosterCandidateSourceStatus(
            rosterCandidateIds: $rosterCandidateIds
            sourceStatus: $sourceStatus
        ) {
            message
            success
        }
    }
`)
